import { Component, forwardRef, OnInit, AfterViewInit, ViewChild, OnDestroy } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-splitline',
  templateUrl: './d-splitline.component.html',
  styles: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DSplitlineComponent),
      multi: true
    }
  ]
})
export class DSplitlineComponent extends DynamicComponentBase implements AfterViewInit {
  static KEY = 'd-splitline';

  constructor() {
    super();
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.config.labelWidth = 0;
    }, 0);
  }
  configChange(config: IDynamicComponentConfig) {}
}
